import React, { useEffect, useState } from "react";
import ApiService from "../../../services/ApiService";
import { toast } from "react-toastify";
import InterviewDetail from "./InterviewDetail";
import { useLocation, useNavigate } from "react-router-dom";
import Paginator from "../../../components/Paginator"; 

const InterviewList = () => {
  const [interviews, setInterviews] = useState([]);
  const [loading, setLoading] = useState(false);

  const [selectedInterview, setSelectedInterview] = useState(null);
  const [pagination, setPagination] = useState({});

  const location = useLocation();
  const navigate = useNavigate();
  const currency = process.env.REACT_APP_CURRENCY;
  const [apiData, setApiData] = useState({
        search: "",
        page: 1,
    });

  const fetchInterviews = async () => {
    try {
      setLoading(true);

      const response = await ApiService.request({
          method: "GET",
          url: "getInterviews", 
          params: apiData
      });
      const data = response.data;

      if (data && data.status === true) {
        setInterviews(data.data);
        setPagination(data.pagination);

      } else {
        toast.error(data.message || "Failed to fetch interviews.");
      }
    } catch (error) {
      console.error("Error fetching interviews:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchInterviews();
  }, [apiData.page, apiData.search]);

  useEffect(() => {
    if (
      location.pathname.includes("dashboard") &&
      location.search.includes("interviews")
    ) {
      setSelectedInterview(null);
    }
  }, [location]);

  const handleInterviewClick = (interview) => {
    const status = interview.user_interview?.status?.trim().toLowerCase();
    if (status === "active" || interview.price < 1) {
      navigate('/dashboard?tab=interviews-details&id='+interview.id);
    } else {
      toast.error("Buy interview first.");
    }
    
  };

  if (selectedInterview) {
    return <InterviewDetail interview={selectedInterview} />;
  }

  const handlePurchase = async (id) => {
    if (!id) {
      toast.error("The interview ID is required");
      return;
    }else{
      navigate('/checkout?interview_id='+id);
    }
    
  };

  const handlePageChange = (event) => {
    setApiData(prev => ({ ...prev, page: event }));
  };



  return (
    <div className="container mt-5 allTestsHeading interview-txt">
      <h4 className="mb-3 card-head">Courses</h4>


      <div className="row m-0 bg-white p-4">
        <div className="row">
          <div className="col-md-5 my-2">
            <input type="search" name="search"  value={apiData.search} onChange={e => setApiData({ ...apiData, search: e.target.value })} className="form-control" placeholder="Search course..." />
          </div>
        </div>
        {loading ? (
          <div className="text-center">
            <span  class="spinner-border spinner-border-sm"
              role="status"  aria-hidden="true" ></span>
            <span class="sr-only mx-2">Loading...</span>
          </div>
        ) : (
          <div className="d-flex flex-wrap px-0">
            {interviews.map((interview, index) => (
              <div
                className="col-md-4 col-sm-6 mb-4 cards-interview px-2 cursor-pointer"
                key={index}     onClick={() => handleInterviewClick(interview)}>
                <div className="card h-100 shadow-sm">
                  <div className="card-img-top bg-light">
                    <img src={interview.thumbnail} className="w-100" alt="" />
                  </div>
                  <div className="card-body">
                    <h5   className="card-title " >
                      {interview.title}
                    </h5>
                      <p className="badge bg-base">
                      {interview?.category?.title }
                      </p> <br />
                    <p className="card-text fs-5 fw-semibold float-start">
                    {interview.price > 0 ?(
                      <span>Price: {currency} {interview.price}</span>
                    ):(
                      <span className="badge bg-success"> Free</span>
                    )}
                      
                    </p>
                    {interview.price < 1 ? (
                      <span className="nothing">  </span>
                      
                    ) : interview.user_interview ? (
                      <p className="badge bg-success float-end">
                        {interview.user_interview.status}
                      </p>
                    ) :  (
                      <button
                        className="btn btn-sm btn-base float-end"
                        onClick={() => handlePurchase(interview.id)}
                      >
                        Buy Now
                      </button>
                    )}
                    <br /> <br />

                    <p className="card-text text-muted ">
                      {interview.description.slice(0, 120)}
                    </p>
                    
                  </div>
                </div>
              </div>
            ))}
            {interviews.length === 0 && <div>No courses available.</div>}
          </div>
        )}
          {pagination.total_pages > 1 && (
              <Paginator
                  page={pagination.current_page}
                  rows={pagination.per_page}
                  totalRecords={pagination.total_records}
                  onPageChange={handlePageChange}
              />
          )}
      </div>
    </div>
  );
};

export default InterviewList;
